class Calendar extends BaseClass {
  templateName = 'calender__setting';

  static payloadProcessor(requestData) {
    return requestData;
  }

  static saveCallback(response) {
    const app = PreBuilt;
    app.notifyEl.update({'message': response.message, progress: 90});
    const calendarId = response.id;
    app.redirect(`/calendar/${calendarId}`);
    app.localStorage.setItem('build-calendar', {id: calendarId});
  }

  constructor(app) {
    super(app);
    this.isRendering = true;
    this.app = app;
    this.observerManager = new ImageObserverManager(this.app, null, null);
  }

  getTemplateData() {

    let options = {
      text: '',
      twitter: '',
      type: 'input',
      modalDialogClass: 'modal-lg modal-dialog-centered  modal-full-height modal-calendar-setting',
      template: this.templateName,
      title: 'New Calendar',
      saveButtonText: 'Create Calendar',
      footerText: '',
      payloadProcessor: 'Calendar.payloadProcessor',
      saveApi: 'calendar.save',
      saveApiCallBack: 'Calendar.saveCallback',
      daysOfMonth: Utils.getDaysOfMonth(),
      placeholderAutoBuildCollapseId: this.app.generateId(),
      placeholderCustomPostsCollapseId: this.app.generateId()
    }

    const page = _.template(this.app.templates['global__checkbox-switch']);
    options.placeholderIsDefault = page({
      label: 'Make this as default calendar',
      id: 'is_default',
      name: 'is_default',
    });
    options.placeholderAutoBuild = page({
      label: 'Auto Build ',
      id: 'autobuild',
      collapse: `#${options.placeholderAutoBuildCollapseId}`,
      name: 'autobuild',
    });
    options.placeholderCustomPosts = page({
      label: 'Smart Sync',
      id: 'custom_posts',
      collapse: `#${options.placeholderCustomPostsCollapseId}`,
      name: 'custom_posts',
    });

    return options;
  }

  async renderBusinessProfile() {
    const self = this;
    const businessProfiles = await self.app.apis['business_profile'].list();
    const $businessProfileInput = self.calendar.find(':input[name=persona_id]');
    $.each(businessProfiles.data, function (key, persona) {
      const $option = $('<option />').attr('value', persona.id).html(persona.name);
      $option.attr('title', JSON.stringify(persona));
      $option.appendTo($businessProfileInput);
    });
    if (!self.app.isEmpty(self.defaultsData)) {
      if (!self.app.isEmpty(self.defaultsData.business_profile)) {
        $businessProfileInput.val(self.defaultsData.business_profile).trigger('click');
      }
    }
    self.initBusinessProfileSelect2(self.calendar, $businessProfileInput);
    return $businessProfileInput;
  }

  async render(defaults) {
    this.isRendering = true;
    const self = this;
    this.defaultsData = defaults;

    this.app.inputPrompt(this.getTemplateData()).then(function ($calendar) {
      self.calendar = $calendar;
      self.initDaysSelect2($calendar, $calendar.find(':input[name=autoBuildDay]'));
      Utils.setSwitchVal($calendar.find(':input[name=custom_posts]'), true, true);
      Utils.setSwitchVal($calendar.find(':input[name=autobuild]'), true, true);
      self.app.initSimpleBar($calendar[0].querySelector('.calendar-setting-wrapper'));

    }).then(async function () {
      const businessProfileInput = await self.renderBusinessProfile();
      self.isRendering = false;
    });

    return self;
  }

  async renderInSide($container) {
    this.isRendering = true;
    const self = this;
    self.calendar = $container;
    const page = _.template(this.app.templates[this.templateName]);
    $container.append(page(self.getTemplateData()));
    await self.renderBusinessProfile();
    self.initDaysSelect2($container, $container.find(':input[name=autoBuildDay]'));
    return self;
  }

  static buildMorePayloadProcessor(requestData) {
    const app = PreBuilt;
    let range = requestData.range;
    range = range.split(' - ');
    range = range.map(date => date.trim());
    requestData = {
      id: app.calendarId,
      range: range
    };
    return requestData;
  }

  static buildMoreSaveCallback(response) {
    const postsCount = Object.keys(response.posts).length;
    const app = PreBuilt;
    app.notifyEl.update({'message': `${postsCount} Posts added to calendar`, progress: 80});
    app.buildMoreModal.modal('hide');
    aimi_calendar.init(app.calendarId);
  }

  static retryPayloadProcessor(requestData) {
    const app = PreBuilt;
    const format = "YYYY-MM-DD hh:mm A"; // Format of the input string
    let scheduleDate = moment(requestData.scheduleDate, format);
    const userTimeZone = app.apis['user'].get().timezone;
    scheduleDate = moment.tz(scheduleDate.format('YYYY-MM-DD HH:mm'), userTimeZone).format();
    requestData = {
      id: requestData.postId,
      scheduleDate: scheduleDate
    };
    app.retryPost = window.calendarPosts[requestData.id];
    return requestData;
  }

  static retrySaveCallback(response) {
    const app = PreBuilt;
    const post = app.retryPost;
    app.retryModal.modal('hide');
    if (!app.isEmpty(app.postActionsContext) && app.postActionsContext.includes('campaign')) {
      const campaignId = app.postActionsContext.split('-')[1];
      PostsList.updateCard(post, post, false, '.tab-content-campaign');
    } else if (!app.isEmpty(app.postActionsContext) && app.postActionsContext.includes('article')) {
      post.post_id = post.id;
      PostsList.updateCard(post, post, false, '.articles-container', true);
    } else {
      PostsList.updateCard(post, post);
    }
  }

  async buildMore() {
    const app = this.app;
    const options = {
      modalDialogClass: 'modal-xl  modal-dialog-scrollable modal-dialog-centered  modal-build-more-posts',
      template: 'calender__build-more-posts',
      title: 'Build More Posts',
      saveButtonText: 'Create Posts',
      footerText: '<span class="fw-semibold"><span class="text-primary"> Note: </span> You can select upto max 90 days</span>',
      payloadProcessor: 'Calendar.buildMorePayloadProcessor',
      saveApi: 'calendar.buildPosts',
      saveApiCallBack: 'Calendar.buildMoreSaveCallback',
    };

    this.app.inputPrompt(options).then(async function ($modal) {
      app.buildMoreModal = $modal;
      const progress = new ProgressBar($modal.find('.container-fluid'));
      progress.start();

      const maxDate = await app.apis['calendar'].maxDate(app.calendarId);

      progress.remove();

      const minDate = maxDate.autoScheduledTillDate;
      const todayDate = moment().format('YYYY-MM-DD');

      let minDateD = new Date(minDate);
      let todayDateD = new Date(todayDate);

      const minBuildDate = minDateD > todayDateD ? minDateD : todayDateD;

      const $input = $modal.find('input');
      const picker = new easepick.create({
        element: $input[0],
        zIndex: 1200,
        calendars: 3,
        grid: 3,
        plugins: [
          "RangePlugin",
          "LockPlugin"
        ],
        LockPlugin: {
          minDate: moment(minBuildDate).format(),
          minDays: 2,
          maxDays: 90,
        },
        css: ['https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css'],
        inline: true
      });

    });
  }

  static filterCallback(response) {
    const app = PreBuilt;
    const status = response.status;
    let range = response.range;
    range = range.split(' - ');
    range = range.map(date => date.trim());
    let posts = _.values(window.calendarPosts);

    if (!app.isEmpty(range)) {
      posts = Utils.filterByDateRange(posts, range[0], range[1]);
    }

    if (!app.isEmpty(status)) {
      posts = posts.filter(obj => {
        return status.includes(obj.actionStatus);
      });
    }

    NoRecordsPlaceholder.destroy();
    Toast.destroy();
    app.filterModal.modal('hide');
    aimi_calendar.refresh(app.calendarId, posts).then(function (response) {

    })

    if (app.isEmpty(posts)) {
      const noRecordsOptions = {
        title: 'No Posts found ',
        description: `I could not find any results for the filter you applied. Remove the filter or try different settings.`,
        addButton: {
          text: 'Clear Filter',
          onClick: () => {
            NoRecordsPlaceholder.destroy();
            aimi_calendar.refresh(app.calendarId, null).then(function (response) {

            })
          }
        },
        help: {
          text: 'Need Help ?',
          onClick: () => {
            console.log('Help clicked');
          }
        },
      };

      app.placeholder = new NoRecordsPlaceholder(app, $('.tab-content-calendar'), noRecordsOptions);
      app.placeholder.render({'class': 'no-records-placeholder m-3'});
    } else {
      let message = [];
      const messageStatic = `Showing results for filters with `;
      if (!app.isEmpty(status)) {
        const statuses = status.join(',')
        message.push(` <span class="fw-semibold">status ${statuses}</span>`)
      }

      if (!app.isEmpty(range)) {
        message.push(`<span class="fw-semibold"> date range ${range[0]} to ${range[1]} </span>`);
      }
      message = messageStatic + message.join(' and ');
      app.Toast = new Toast(app, $('.tab-content-calendar'), {
        'message': message, closeButton: {
          text: 'Clear Filter',
          onClick: () => {
            Toast.destroy();
            aimi_calendar.refresh(app.calendarId, null).then(function (response) {

            })
          }
        }
      });
      app.Toast.render();
    }
  }

  async filter() {
    const app = this.app;
    const options = {
      modalDialogClass: 'modal-xl  modal-dialog-scrollable modal-dialog-centered  modal-filter-posts',
      template: 'calender__filter-posts',
      title: 'Filter Posts',
      saveButtonText: 'Filter',
      footerText: '',
      saveApi: '',
      saveApiCallBack: 'Calendar.filterCallback',
    };

    this.app.inputPrompt(options).then(async function ($modal) {
      app.filterModal = $modal;
      const progress = new ProgressBar($modal.find('.container-fluid'));
      progress.start();

      const maxDate = await app.apis['calendar'].maxDate(app.calendarId);

      progress.remove();

      const $input = $modal.find('input[name=range]');
      const picker = new easepick.create({
        element: $input[0],
        zIndex: 1200,
        calendars: 3,
        grid: 3,
        plugins: [
          "RangePlugin",
          "LockPlugin"
        ],
        LockPlugin: {
          minDays: 2,
          maxDays: 90,
        },
        css: ['https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css'],
        inline: true
      });

    });
  }

  initDaysSelect2($calendar, $input) {
    const app = this.app;
    // Create a new Date object for the current date
    const today = new Date();
    // Get the day of the month using getDate()
    const dayOfMonth = today.getDate();

    $input.val(dayOfMonth);
    $input.select2({
      dropdownParent: $calendar,
      dropdownCssClass: 'font-select2-dropdown',
      selectionCssClass: 'font-select2-selection',
      theme: 'bootstrap-5'
    });
  };

  initBusinessProfileSelect2($calendar, $input) {
    const $formControlLoader = $input.closest('.form-control-loader');
    const app = this.app;
    const self = this;

    const formatState = function (state) {
      if (!state.id) {
        return state.text;
      }
      const $state = $(`<span><span class="d-flex"><div class="me-auto first-column">${state.text}</div><div class="second-column w-100p"></div></span></span>`);
      const title = JSON.parse(state.title);
      let graphics;

      if (!app.isEmpty(title) && !app.isEmpty(title.config)) {
        title.config = JSON.parse(title.config);
        graphics = title.config.graphics || {};
      }

      const image =
          `<div class="row-image-wrapper post-image-wrapper ms-2 mw-50p">
            <div  class="image-wrapper rounded-8  active as-placeholder-glow ">
              <div class="row-image post-image rounded-2 as-placeholder " data-type="image" data-src="<%= image %>" ></div>
            </div>
          </div>`

      const $image = _.template(image);
      const $column = $state.find('.second-column')
      // Graphics Logo and headshot
      if (!app.isEmpty(graphics) && !app.isEmpty(graphics.headshot)) {
        const $page = $($image({image: graphics.headshot.thumb}));
        $page.appendTo($column);
      }

      // Graphics Logo and headshot
      if (!app.isEmpty(graphics) && !app.isEmpty(graphics.image)) {
        const $page = $($image({image: graphics.image.thumb}));
        $page.appendTo($column);
      }

      let $images = $('[data-type="image"]', $state);
      $images.each(function (index, image) {
        if ($(image).attr('data-src') !== '') {
          self.observerManager.observeIntersection(image);
        }
      });

      return $state;
    };

    $input.select2({
      dropdownParent: $calendar,
      dropdownCssClass: 'font-select2-dropdown',
      selectionCssClass: 'font-select2-selection',
      theme: 'bootstrap-5', templateResult: formatState
    });

    $formControlLoader.removeClass('m-progress');
  };
}

// Creating a map of class references
window["Calendar"] = Calendar;